import { useState } from "react";
import "./FAQ.css";

const faqData = [
  {
    question: "Does Xyncely replace my existing tools?",
    answer:
      "No. Xyncely integrates with your CRM, ad platforms, analytics tools, and social channels. Think of it as the connective layer that brings everything together rather than a replacement for your existing stack.",
  },
  {
    question: "How long does it take to set up?",
    answer:
      "Xyncely is designed for a quick setup. Connect your existing tools, configure your workspace, and start managing campaigns from one place.",
  },
  {
    question: "Can I manage multiple brands or clients from one account?",
    answer:
      "Yes. You can manage multiple brands, clients, campaigns, and teams from a single workspace.",
  },
  {
    question: "Is Xyncely secure and compliant?",
    answer:
      "Yes. Xyncely is designed with security and controlled access in mind, helping teams manage campaign information safely.",
  },
  {
    question: "Does it support content approval and version history?",
    answer:
      "Yes. Teams can review, approve, and keep track of content changes throughout the campaign workflow.",
  },
  {
    question: "Can we track barter, product and paid collaborations?",
    answer:
      "Yes. Xyncely supports different collaboration models, including barter, product-based, and paid creator collaborations.",
  },
  {
    question: "Is Xyncely only for social campaigns?",
    answer:
      "No. Xyncely is built to manage broader creator and influencer campaign workflows across multiple collaboration types.",
  },
];

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(0);

  const handleToggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="faq-section">
      <div className="faq-section__container">

        {/* Header */}
        <div className="faq-section__header">
          <span className="faq-section__eyebrow">
            FAQ
          </span>

          <h2>Common questions answered.</h2>

          <p>
            Everything you need to know before getting started.
          </p>
        </div>

        {/* FAQ List */}
        <div className="faq-list">
          {faqData.map((faq, index) => {
            const isOpen = openIndex === index;

            return (
              <div
                className={`faq-item ${isOpen ? "faq-item--open" : ""}`}
                key={faq.question}
              >
                <button
                  type="button"
                  className="faq-item__question"
                  onClick={() => handleToggle(index)}
                >
                  <span>{faq.question}</span>

                  <span className="faq-item__icon">
                    {isOpen ? "⌃" : "⌄"}
                  </span>
                </button>

                {isOpen && (
                  <div className="faq-item__answer">
                    <p>{faq.answer}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>

      </div>
    </section>
  );
};

export default FAQ;